<template>
  <el-card
    class="ds-detail"
    style="position: relative; z-index: 0; width: 100%"
  >
    <div slot="header" class="clearfix">
      <el-button @click="$router.back()" class="pull-left">
        <i class="fa fa-chevron-left fa-fw"></i> 返回 </el-button
      >&nbsp;
      <el-tag size="medium">{{ item.Name }}</el-tag>
    </div>
    <div style="margin-bottom: 15px">
      <div class="border-style">合同信息</div>
      <table
        border="1"
        bordercolor="#dedede"
        style="width: 100%; border-collapse: collapse"
      >
        <tr>
          <th width="15%">合同编号</th>
          <td width="35%">{{ item.ContractNumber }}</td>
          <th width="15%">合同名称</th>
          <td width="35%">{{ item.Name }}</td>
        </tr>
        <tr>
          <th>所属客户</th>
          <td>
            <div v-if="item.Client">{{ item.Client.ClientName }}</div>
          </td>
          <th>合同签订日期</th>
          <td>
            <div v-if="item.CheckDay">
              {{ item.CheckDay.substring(0, 10) }}
            </div>
          </td>
        </tr>
        <tr>
          <th>合同开始日期</th>
          <td>
            <div v-if="item.ContractStartDay">
              {{ item.ContractStartDay.substring(0, 10) }}
            </div>
          </td>
          <th>合同结束日期</th>
          <td>
            <div v-if="item.ContractEndDay">
              {{ item.ContractEndDay.substring(0, 10) }}
            </div>
          </td>
        </tr>
        <tr>
          <th colspan="1">备注</th>
          <td colspan="3">{{ item.Remark }}</td>
        </tr>
        <tr>
          <th colspan="1">迁移说明</th>
          <td colspan="3">
            <el-collapse v-if="item.MigrateRemark">
              <el-collapse-item>
                <template slot="title">
                  <span v-if="item.MigrateRemark.length === 0"></span>
                  <span v-else
                    >共{{ item.MigrateRemark.length }}条迁移说明</span
                  >
                </template>
                <div v-for="remark in item.MigrateRemark" :key="remark">
                  <hr />
                  {{ remark }}
                </div>
              </el-collapse-item>
            </el-collapse>
          </td>
        </tr>
      </table>
    </div>
    <div style="margin-bottom: 15px">
      <div class="border-style">工控软件产品销售信息</div>
      <div class="toolbar">
        <el-button type="primary" size="mini" @click="onCreateSaleInfoClick">
          <i class="fas fa-plus"></i> 新 增
        </el-button>
      </div>
      <el-table :data="saleInfoList" v-loading="loading" size="medium">
        <el-table-column prop="Value" label="工控软件产品名称" />
        <el-table-column prop="SaleNum" label="销售数量" width="100" />
        <el-table-column prop="Remark" label="备注" width="350" />
        <el-table-column width="100" label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              @click.stop="onEditSaleInfoClick(scope.row)"
              title="编辑"
            >
              <i class="fas fa-pencil-alt"></i>
            </el-button>
            <el-button
              type="danger"
              @click.stop="onDeleteSaleInfo(scope.row)"
              title="删除"
            >
              <i class="fas fa-trash-alt"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div style="margin-bottom: 10px" v-if="!ipcodeShow">
      <el-button type="primary" @click="getIpccodeList()" title="授权码查询">
        <i class="fas fa-list"></i> 授权码 </el-button
      >&nbsp;
    </div> -->

    <div style="margin-bottom: 10px" v-if="ipcodeShow">
      <div class="border-style">授权码</div>
      <div style="margin-bottom: 10px">
        <el-button type="primary" size="mini" @click="onCreateItem()">
          <i class="fas fa-plus"></i> 新增授权码 </el-button
        >&nbsp;
        <el-button type="primary" size="mini" @click="onUpdateItem()">
          <i class="fas fa-upload"></i> 更新授权码 </el-button
        >&nbsp;
        <el-button type="primary" size="mini" @click="onInItem()">
          <i class="fas fa-upload"></i> 迁入授权码 </el-button
        >&nbsp;
        <el-button type="primary" size="mini" @click="onMoveItem()">
          <i class="fas fa-upload"></i> 迁出授权码
        </el-button>
      </div>
      <el-table :data="codes" v-loading="loading">
        <el-table-column
          type="index"
          :index="pager.size * (pager.page - 1) + 1"
          width="50"
        ></el-table-column>
        <!-- <el-table-column
          prop="BusinessType.Name"
          label="业务类型"
          width="70"
        ></el-table-column> -->
        <el-table-column label="软件产品/授权码">
          <template slot-scope="scope">
            <div v-if="scope.row.Software">
              {{ scope.row.Software.Name }}_{{ scope.row.TargetVersion }}_{{
                scope.row.Function.Name
              }}
            </div>
            <div v-if="scope.row.Name">
              <el-tag type="success">
                {{ formatStr(scope.row.Name) }}
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="Name" label="授权码" width="280">
          <template slot-scope="{ row }">
           <el-tag type="success">
              {{ formatStr(row.Name) }}
            </el-tag>
          </template>
        </el-table-column> -->
        <el-table-column label="目标软件产品/授权码">
          <template slot-scope="scope">
            <div v-if="scope.row.TargetSoftware">
              {{ scope.row.TargetSoftware.Name }}_{{
                scope.row.NewTargetVersion
              }}_{{ scope.row.TargetFunction.Name }}
            </div>
            <div v-if="scope.row.TargetCode">
              <el-tag type="success">
                {{ formatStr(scope.row.TargetCode) }}
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="TargetCode" label="目标授权码">
          <template slot-scope="{ row }">
            {{ formatStr(row.TargetCode) }}
          </template>
        </el-table-column> -->
        <!-- <el-table-column label="当前绑定日期">
          <template slot-scope="scope">
            <div v-if="scope.row.BindRecord">{{scope.row.BindRecord.BindDay.substring(0,10)}}</div>
          </template>
        </el-table-column>-->
        <el-table-column label="当前绑定站点" width="250">
          <template slot-scope="scope">
            <!-- <div v-if="scope.row.Station">{{ scope.row.Station.Name }}</div>-->
            <el-link type="primary" v-if="scope.row.Station" :underline="false">
              <a
                target="_self"
                class="buttonText"
                @click="showStaton(scope.row)"
                >{{ scope.row.Station.Name }}</a
              >
            </el-link>
          </template>
        </el-table-column>

        <!-- <el-table-column label="产品型号" width="150">
        <template slot-scope="{ row }">
          <div v-if="row.IpcProduct && row.IpcProduct.IpcProductModel">
            {{ row.IpcProduct.IpcProductModel.Name }}
          </div>
          <div
            style="padding-top: 5px"
            v-if="row.IpcProduct && row.IpcProduct.IpcProductModel"
          >
            {{ row.IpcProduct.IpcProductModel.Number }}
          </div>
        </template></el-table-column
      > -->
       <el-table-column label="硬件产品型号/SN" width="200">
        <template slot-scope="{ row }">
          <div v-if="row.IpcProduct && row.IpcProduct.IpcProductModel">
            {{ row.IpcProduct.IpcProductModel.Name }}
          </div>
          <div v-if="row.IpcProduct">
            <!-- <el-tag>{{ row.IpcProduct.SN }}</el-tag> -->
            <el-link type="primary">
              <a target="_self" class="buttonText" @click="showProduct(row)">{{
                row.IpcProduct.SN
              }}</a>
            </el-link>
          </div>
        </template>
      </el-table-column>
        <el-table-column
          prop="BindRecordsCount"
          label="使用次数"
          width="70"
        ></el-table-column>
        <el-table-column width="50" label="操作">
          <template slot-scope="scope">
            <!-- <el-button type="primary" @click.stop="showRecord(scope.row)" title="使用记录">
              <i class="fas fa-list"></i>
            </el-button>-->
            <el-button
              type="danger"
              @click.stop="onDeleteItem(scope.row)"
              title="删除"
              :disabled="scope.row.BindRecordsCount !== 0"
            >
              <i class="fas fa-trash-alt"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="clearfix mar-top-10">
        <el-pagination
          class="pull-right"
          @current-change="onChangePage"
          layout="total, prev, pager, next"
          :total="pager.total"
          :current-page="pager.page"
          :page-size="pager.size"
        ></el-pagination>
      </div>
    </div>
    <create-code
      v-model="item"
      :visible.sync="itemVisible"
      @form:saved="updateItem"
    />
    <update-code
      v-model="item"
      :visible.sync="updateVisible"
      @form:saved="updateItem"
    />
    <move-code
      v-model="item"
      :visible.sync="moveVisible"
      @form:saved="updateItem"
    />
    <in-code
      v-model="item"
      :visible.sync="inVisible"
      @form:saved="updateItem"
    />

    <el-dialog
      title="站点信息"
      :visible.sync="showVisible"
      @close="showVisible = false"
      width="80%"
      top="5%"
      append-to-body
      :close-on-click-modal="false"
      ><show-station :ID="statonID" :showBack="false" :key="statonID" />
    </el-dialog>

    <el-dialog
      title="销售信息"
      :visible.sync="saleInfoVisible"
      append-to-body
      :close-on-click-modal="false"
      @close="onCloseSaleInfoItem"
      width="40%"
    >
      <el-form
        ref="saleInfoItemForm"
        label-width="120px"
        :model="saleInfoItem"
        :rules="saleInfoRules"
      >
        <el-form-item label="工控产品名称" prop="Key">
          <el-select
            v-model="saleInfoItem.Key"
            filterable
            default-first-option
            placeholder="请选择工控产品名称"
            style="width: 100%"
          >
            <el-option
              v-for="soft in softwareList"
              :key="soft.Key"
              :label="soft.Value"
              :value="soft.Key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="销售数量" prop="SaleNum">
          <el-input-number
            v-model="saleInfoItem.SaleNum"
            :min="0"
            style="width: 100%"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input
            v-model.trim="saleInfoItem.Remark"
            :autosize="{ minRows: 2 }"
            type="textarea"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCloseSaleInfoItem">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button type="primary" @click="onConfirmSaleInfoItem">
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="硬件产品信息"
      :visible.sync="productVisible"
      @close="productVisible = false"
      width="60%"
      top="5%"
      append-to-body
      :close-on-click-modal="false"
      ><show-product :ID="productID" :showBack="false" :key="productID" />
    </el-dialog>
  </el-card>
</template>

<script>
import CreateCode from "./create--code.vue";
import UpdateCode from "./update--code.vue";
import MoveCode from "./move--code.vue";
import InCode from "./in--code.vue";
import ShowStation from "../../pn/station/index--detail.vue";
import ShowProduct from "../../ipc/productInout/detail.vue";

export default {
  components: {
    CreateCode,
    UpdateCode,
    MoveCode,
    InCode,
    ShowStation,
    ShowProduct,
  },
  data() {
    return {
      item: {},
      codes: [],
      pager: {
        total: 0,
        page: 1,
        size: 10,
      },
      loading: false,
      itemVisible: false,
      updateVisible: false,
      moveVisible: false,
      inVisible: false,
      fold: true,
      ipcodeShow: false, // 是否显示授权码

      softwareList: [], //工控软件产品列表
      saleInfoList: [], //工控销售信息列表
      saleInfoVisible: false,
      saleInfoItem: {},
      saleInfoRules: {
        Key: [
          { required: true, message: "工控产品名称不能为空", trigger: "blur" },
        ],
        SaleNum: [
          { required: true, message: "销售数量不能为空", trigger: "blur" },
        ],
      },
      maxNum: 0, //记录最大数
      saleInfo: [], //工控销售信息JSON
      showVisible: false,
      productVisible: false,
      statonID: "",
      productID:"",
    };
  },
  mounted() {
    this.getItemData();
    this.getPermission();
    this.getSoftwareList();
  },
  created() {
    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem('store'))
        )
      )
    }
 
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    // beforeunload事件在页面刷新时先触发
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
  },
  methods: {
    handleFold() {
      this.fold = !this.fold;
    },
    updateItem() {
      this.getItemData();
      this.getIpccodeList();
    },
    getItemData() {
      this.$axios
        .get(`contract/${this.$route.params.ID}`, {
          params: { with: ["Client"] },
        })
        .then((response) => {
          this.item = response.data.data;

          this.saleInfoList = [];
          if (this.item.SaleInfo != null && this.item.SaleInfo.length > 0) {
            this.maxNum = this.item.SaleInfo.length;
            for (let index = 0; index < this.item.SaleInfo.length; index++) {
              let element = this.item.SaleInfo[index];
              this.saleInfoList.push({
                ID: index + 1,
                Key: element.Key,
                Value: element.Value,
                SaleNum: element.SaleNum,
                Remark: element.Remark,
              });
            }
          }
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getIpccodeList();
    },
    getSoftwareList() {
      this.$axios
        .get("software/version/function")
        .then((response) => {
          this.softwareList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    // 获取授权码
    getIpccodeList() {
      this.$axios
        .get(`ipccode/contract/${this.$route.params.ID}`, {
          params: {
            with: [
              "Software",
              "BusinessType",
              "Function",
              "BindRecords/count",
              "TargetSoftware",
              "TargetFunction",
              "Station",
            ],
            order: ["bind_records_count"],
            ...this.pager,
          },
        })
        .then((response) => {
          this.codes = response.data.data;
          // this.ipcodeShow = true;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          // this.ipcodeShow = false;
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatStr(str) {
      let value = "";
      if (str) {
        for (let i = 0; i < 5; i++) {
          if (i === 0) {
            value = str.substring(0, 5);
          } else if (str.substring(i * 5, i * 5 + 5)) {
            value = `${value}-${str.substring(i * 5, i * 5 + 5)}`;
          }
        }
      }
      return value;
    },
    onCreateItem() {
      this.itemVisible = true;
    },
    onUpdateItem() {
      this.updateVisible = true;
    },
    onMoveItem() {
      this.moveVisible = true;
    },
    onInItem() {
      this.inVisible = true;
    },
    onDeleteItem(row) {
      this.$confirm("确定要删除该授权码吗？", "提示")
        .then(() => this.$axios.delete(`ipccode/${row.ID}`))
        .then(() => {
          this.getIpccodeList();
          this.$message.success("成功删除");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    showStaton(row) {
      this.statonID = row.Station.ID;
      this.showVisible = true;
    },

    getPermission() {
      if (this.$store.state.Auth.user.Permissions) {
        this.$store.state.Auth.user.Permissions.forEach((perm) => {
          if ("ipc_code-*" === perm.Obj + "-" + perm.Act) {
            this.ipcodeShow = true;
            this.getIpccodeList();
          }
        });
      }
    },

    showProduct(row) {
      this.productID = row.IpcProduct.ID;
      this.productVisible = true;
    },

    // ===========工控销售信息============
    //点击新增销售信息按钮
    onCreateSaleInfoClick() {
      this.saleInfoItem = this.getEmptySaleInfoItem();
      this.saleInfoVisible = true;
    },

    //编辑销售信息
    onEditSaleInfoClick(row) {
      this.saleInfoItem = this.getEmptySaleInfoItem();

      this.saleInfoItem.ID = row.ID;
      this.saleInfoItem.Key = row.Key;
      this.saleInfoItem.Value = row.Value;
      this.saleInfoItem.SaleNum = row.SaleNum;
      this.saleInfoItem.Remark = row.Remark;

      this.saleInfoVisible = true;
    },

    //确认新增/保存销售信息
    onConfirmSaleInfoItem() {
      this.$refs.saleInfoItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$emit("input", this.saleInfoItem);
        let itemData = { ...this.saleInfoItem };

        let isHave = false;
        this.saleInfoList.forEach((element) => {
          if (element.Key === itemData.Key && element.ID !== itemData.ID) {
            isHave = true;
          }
        });
        if (isHave) {
          this.$message({
            type: "warning",
            message: "工控软件产品名称不能重复",
            duration: 1500,
          });
          return;
        }

        this.softwareList.forEach((item) => {
          if (item.Key === itemData.Key) {
            itemData.Value = item.Value;
          }
        });

        //新增参数
        if (itemData.ID === 0) {
          this.maxNum += 1;
          itemData.ID = this.maxNum;
          this.saleInfoList.push(itemData);
        } else {
          //编辑参数
          for (let index = 0; index < this.saleInfoList.length; index++) {
            if (this.saleInfoList[index].ID === itemData.ID) {
              this.$set(this.saleInfoList, index, itemData);
              break;
            }
          }
        }

        //工控销售信息保存
        this.item.SaleInfo = [];
        for (let index = 0; index < this.saleInfoList.length; index++) {
          let element = this.saleInfoList[index];
          this.item.SaleInfo.push({
            Key: element.Key,
            Value: element.Value,
            SaleNum: element.SaleNum,
            Remark: element.Remark,
          });
        }

        // 保存的操作
        this.$axios
          .request({
            url: `contract/${this.item.ID}`,
            method: "put",
            data: this.item,
          })
          .then(() => {
            this.$message.success("操作成功");
            this.saleInfoVisible = false;
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
          });
      });
    },

    //删除销售信息
    onDeleteSaleInfo(row) {
      this.$confirm("确定要删除该信息吗？", "提示")
        .then(() => {
          for (let index = 0; index < this.saleInfoList.length; index++) {
            const element = this.saleInfoList[index];
            if (element.ID === row.ID) {
              this.saleInfoList.splice(index, 1);
              break;
            }
          }

          //工控销售信息保存
          this.item.SaleInfo = [];
          for (let index = 0; index < this.saleInfoList.length; index++) {
            let element = this.saleInfoList[index];
            this.item.SaleInfo.push({
              Key: element.Key,
              Value: element.Value,
              SaleNum: element.SaleNum,
              Remark: element.Remark,
            });
          }

          // 保存的操作
          this.$axios
            .request({
              url: `contract/${this.item.ID}`,
              method: "put",
              data: this.item,
            })
            .then(() => {
              this.$message.success("操作成功");
            })
            .catch(({ response }) => {
              this.$sys.alarmResponse(response);
            });
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },

    getEmptySaleInfoItem() {
      return {
        ID: 0,
        Key: "", //对应获取工控产品列表key
        Value: "", //对应获取工控产品列表key
        SaleNum: 0, //销售数量
        Remark: "", //备注
      };
    },

    onCloseSaleInfoItem() {
      this.saleInfoVisible = false;
      this.$refs.saleInfoItemForm.resetFields();
    },
  },
};
</script>

<style scoped lang="scss">
.ds-detail {
  .el-tabs__header {
    z-index: 0;
  }
  .fix-width {
    width: 120px;
  }
  table th td,
  table tr td {
    padding: 2px 5px;
    height: 30px;
    line-height: 30px;
  }
  table th {
    text-align: left;
    padding-left: 5px;
    color: #646566;
  }
  .border-style {
    height: 28px;
    line-height: 28px;
    border-radius: 0 15px 15px 0;
    border-left: 3px solid #409eff;
    padding-left: 5px;
    margin-bottom: 10px;
    background-color: #ecf5ff;
    color: #409eff;
  }
}
.fold {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
</style>
